import { readdirSync, readFileSync } from 'fs'
import matter from 'gray-matter'
import path from 'path'

const getLinks = (locale: string | undefined, links?: string[]) => {
  const linksFiles = path.join(process.cwd(), `./src/content/${locale}/links`)
  let files
  try {
    files = readdirSync(linksFiles)
  } catch (error) {
    return []
  }
  const linksArr = files.map((file) => {
    const fullPath = path.join(linksFiles, file)
    const contents = readFileSync(fullPath, 'utf8')
    const { data } = matter(contents)

    return { ...data }
  })

  if (links) {
    const sortedLinks = links
      .map((link) => linksArr.find((linkArr) => linkArr.id === link))
      .filter(Boolean)

    return sortedLinks.filter((link) => link.active)
  }

  const activeLinks = linksArr.filter((link) => link.active)

  return activeLinks.map((link) => {
    return link.id
  })
}

export default getLinks
